import { render, staticRenderFns } from "./ScenicSpotsManage.vue?vue&type=template&id=07e85a46&scoped=true"
import script from "./ScenicSpotsManage.vue?vue&type=script&lang=js"
export * from "./ScenicSpotsManage.vue?vue&type=script&lang=js"
import style0 from "./ScenicSpotsManage.vue?vue&type=style&index=0&id=07e85a46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e85a46",
  null
  
)

export default component.exports